import styled from "styled-components";

import Container from "components/Container";

const ContainerAd = styled(Container)`
  min-height: 100%;
  padding-top: 0;
  height: 300px;
  background-color: #ffffff;

  @media (max-width: 420px) {
    width: 100%;
    height: 360px;
  }
`;

export default ContainerAd;